<span [class]="formattedTextClass">{{ formatted }}</span>